module.exports = __webpack_public_path__ + "files/448cb0dbd463e41bf34b7bd9999bb165.png";